// extracted by mini-css-extract-plugin
export default {"Game":"Game_Game__FVGUk","Game__back":"Game_Game__back__plhFi","Game__container":"Game_Game__container__zxozy"};